import React from 'react';
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TransactionsHistory from './TransactionsHistory';
    const newPage = () => {
        //meta title
        document.title="أرشيف الفواتير | DBsaloni Admin & Dashboard ";
        return (
            <>
                <div className="page-content">
                    <Container fluid={false}>
                        <Breadcrumbs title=" أرشيف الفواتير" breadcrumbItem="الفواتير" />
                        <TransactionsHistory />
                    </Container>
                </div>
            </>
        );
    }

export default newPage;